import MallabhumPrayas from "../MallabhumPrayas";
import { Link } from "react-router";

function Footer() {
  return (
    <>
      <footer id="footer" className="footer dark-background">
        <div className="container footer-top">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6 footer-about">
              <span
                href="index.html"
                className="logo d-flex align-items-center"
              >
                <span className="sitename">
                  <div>
                    <MallabhumPrayas isDialogueRequired />
                  </div>
                </span>
              </span>

              <div className="social-links d-flex mt-4">
                <a href="https://www.facebook.com/mallabhum.prayas/" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-facebook" />
                </a>                                
                <a href="https://x.com/mallabhumprayas" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-twitter-x" />
                </a>
                <a  href="https://www.instagram.com/mallabhum_prayas/?igsh=MTFvOGxydHdhb2lpNw%3D%3D#" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-instagram" />
                </a>
                <a href="https://www.youtube.com/@MALLABHUMPRAYAS" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-youtube" />
                </a>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <Link to="/home">Home</Link>
                </li>
                <li>
                  <Link to="/donate-us">Donate-us</Link>
                </li>
                <li>
                  <Link to="/team">Our Team</Link>
                </li>
                <li>
                  <Link to="/contact">Contact us</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-3 footer-links">
              <h4>Our Popular Initiatives</h4>
              <ul>
                <li>
                  <Link to="/zero-wastage-food">Zero Wastage Food</Link>
                </li>
                <li>
                  <Link to="/bina-paysar-bazar">Bina payasar bazar</Link>
                </li>
                <li>
                  <Link to="/free-napkin">Free napkin service</Link>
                </li>
                <li>
                  <Link to="/dbd">Direct Blood Donation</Link>
                </li>
                <li>
                  <Link to="/medical-help">Ambulance/Oxygen Service</Link>
                </li>
                <li>
                  <Link to="/education-help">Education Help</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-12 footer-links">
              <h4>Our Address</h4>
              <div className="footer-contact pt-3">
                <p>Gitarani Ghosh Smri Mandir,</p>
                <p>Kumaritaki More, PO- Bishnupur</p>
                <p>District – Bankura, Pin – 722122</p>
                <p className="mt-3">
                  <strong>Phone:</strong>{" "}
                  <span>+91 90643 12816/+91 83450 40440</span>
                </p>
                <p>
                  <strong>Email:</strong>{" "}
                  <span>
                    help@mallabhumprayas.org / mallabhumprayas@gmail.com
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container copyright text-center mt-4">
          <div>
            © <span>Copyright</span>{" "}
            <span>
              <MallabhumPrayas small />
            </span>
            <span>All Rights Reserved</span>
          </div>
          <div className="credits">
            Designed by <Link to="/team">Team Mallabhum Prayas</Link>
          </div>
        </div>
      </footer>
      <a href="/"></a>
    </>
  );
}

export default Footer;
